<template>
  <div class="uni-searchbar">
    <div
      :style="{ borderRadius: radius + 'px', backgroundColor: bgColor }"
      class="uni-searchbar__box"
      @click="searchClick"
    >
      <div class="uni-searchbar__box-icon-search">
        <slot name="searchIcon">
          <!-- <uni-icons color="#888" size="18" type="search" /> -->
          <img class="search" src="@funcPuzzle/mini_doctor/new_search.png" />
        </slot>
      </div>
      <input
        v-if="show || inputValue"
        v-model="inputValue"
        :focus="showSync"
        :placeholder="placeholder"
        :maxlength="maxlength"
        :adjust-position="false"
        class="uni-searchbar__box-search-input"
        confirm-type="search"
        type="text"
        @confirm="confirm"
        @focus="inputFocus"
        @blur="blur"
        @input="onInput"
        @keyup.enter="confirm"
      />
      <span v-else class="uni-searchbar__text-placeholder">
        {{ placeholder }}
      </span>
      <div
        v-if="show && (clearButton === 'always' || (clearButton === 'auto' && searchVal !== ''))"
        class="uni-searchbar__box-icon-clear"
        @click="clear"
      >
        <slot name="clearIcon">
          <uni-icons color="#c0c4cc" size="18" type="clear" />
        </slot>
      </div>
    </div>
    <span
      v-if="cancelButton === 'always' || (show && cancelButton === 'auto')"
      class="uni-searchbar__cancel"
      @click="cancel"
    >
      {{ cancelText }}
    </span>
  </div>
</template>

<script>
import uniIcons from '../uni-icons/uni-icons.vue'
import { debounce } from '@/utils/debounce.js'

/**
 * SearchBar 搜索栏
 * @description 评分组件
 * @tutorial https://ext.dcloud.net.cn/plugin?id=866
 * @property {Number} radius 搜索栏圆角
 * @property {Number} maxlength 输入最大长度
 * @property {String} placeholder 搜索栏Placeholder
 * @property {String} clearButton = [always|auto|none] 是否显示清除按钮
 * 	@value always 一直显示
 * 	@value auto 输入框不为空时显示
 * 	@value none 一直不显示
 * @property {String} cancelButton = [always|auto|none] 是否显示取消按钮
 * 	@value always 一直显示
 * 	@value auto 输入框不为空时显示
 * 	@value none 一直不显示
 * @property {String} cancelText 取消按钮的文字
 * @property {String} bgColor 输入框背景颜色
 * @property {Boolean} focus 是否自动聚焦
 * @event {Function} confirm uniSearchBar 的输入框 confirm 事件，返回参数为uniSearchBar的value，e={value:Number}
 * @event {Function} input uniSearchBar 的 value 改变时触发事件，返回参数为uniSearchBar的value，e=value
 * @event {Function} cancel 点击取消按钮时触发事件，返回参数为uniSearchBar的value，e={value:Number}
 * @event {Function} clear 点击清除按钮时触发事件，返回参数为uniSearchBar的value，e={value:Number}
 * @event {Function} blur input失去焦点时触发事件，返回参数为uniSearchBar的value，e={value:Number}
 */

export default {
  name: 'UniSearchBar',
  components: {
    uniIcons
  },
  props: {
    placeholder: {
      type: String,
      default: '请输入搜索内容'
    },
    radius: {
      type: [Number, String],
      default: 5
    },
    clearButton: {
      type: String,
      default: 'auto'
    },
    cancelButton: {
      type: String,
      default: 'auto'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    bgColor: {
      type: String,
      default: '#F8F8F8'
    },
    maxlength: {
      type: [Number, String],
      default: 100
    },
    value: {
      type: [Number, String],
      default: ''
    },
    focus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchVal: undefined,
      show: false,
      showSync: false
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    inputValue: {
      handler(newVal) {
        if (newVal) {
          this.show = true
        }
      },
      immediate: true
    },
    value: {
      handler(newVal) {
        if (newVal) {
          this.show = true
        }
      },
      immediate: true
    },
    focus: {
      handler(newVal) {
        if (newVal) {
          this.show = true
          setTimeout(_ => {
            this.showSync = true
          }, 1000)
        }
      }
    }
  },
  methods: {
    searchClick() {
      if (this.show) {
        return
      }
      this.show = true
      this.$nextTick(() => {
        this.showSync = true
      })
    },
    clear() {
      this.inputValue = ''
      this.$emit('clear', { value: '' })
    },
    cancel() {
      this.$emit('cancel', { value: this.inputValue })
      this.show = false
      this.showSync = false
      // uni.hideKeyboard()
    },
    confirm() {
      // uni.hideKeyboard()
      this.$emit('confirm', {
        value: this.searchVal
      })
    },
    onInput() {
      debounce(() => {
        this.$emit('input', this.inputValue)
        this.$emit('oninput', this.inputValue)
      }, 600)
    },
    blur() {
      // uni.hideKeyboard()
      this.showSync = false
      this.$emit('blur', { value: this.inputValue })
    },
    inputFocus(val) {}
  }
}
</script>

<style lang="scss" scoped>
.uni-searchbar {
  display: flex;
  flex-direction: row;
  position: relative;
  padding: 0.682667rem;
  // background-color: $uni-bg-color;
}

.uni-searchbar__box {
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  flex: 1;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  height: 1.706667rem;
  padding: 0.106667rem 0.170667rem 0.106667rem 0rem;
  border-width: 0.010667rem;
  border-style: solid;
  border-color: #cecece;
  border-radius: 0.853333rem !important;
}

.uni-searchbar__box-icon-search {
  flex-direction: row;
  // width: .682667rem;
  padding: 0 0.341333rem 0.085333rem 0.341333rem;
  justify-content: center;
  align-items: center;
  color: #888;
  .search {
    width: 0.661333rem;
    height: 0.661333rem;
  }
}

.uni-searchbar__box-search-input {
  display: block;
  flex: 1;
  font-size: 0.64rem;
  line-height: 1.706667rem;
  color: #222;
  border: none;
}

.uni-searchbar__box-icon-clear {
  align-items: center;
  line-height: 0.512rem;
  padding-left: 0.170667rem;
  cursor: pointer;
}

.uni-searchbar__text-placeholder {
  font-size: 0.64rem;
  color: #cecece;
  // margin-left: .106667rem;
}

.uni-searchbar__cancel {
  padding-left: 0.213333rem;
  line-height: 1.706667rem;
  font-size: 0.597333rem;
  color: $uni-text-color;
  cursor: pointer;
}
</style>
